import { render, staticRenderFns } from "./NxProducts.vue?vue&type=template&id=360f3598&scoped=true"
import script from "./NxProducts.vue?vue&type=script&lang=js"
export * from "./NxProducts.vue?vue&type=script&lang=js"
import style0 from "./NxProducts.vue?vue&type=style&index=0&id=360f3598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f3598",
  null
  
)

export default component.exports